import { HttpInterceptorFn } from "@angular/common/http";

import { environment } from "src/environments/environment";

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem(environment.tokenPropertyName);
  const currentLang = localStorage.getItem("currentLang") || environment.defaultLanguage;

  req = req.clone({
    url: `${environment.DOMAIN_API}${req.url}`,
    setHeaders: {
      Authorization: token ? `Bearer ${token}` : "",
      "Accept-Language": currentLang,
      "Access-Control-Allow-Origin": "*",
      "Cache-Control": "no-store, must-revalidate",
      "X-Frame-Options": "DENY",
      "X-Content-Type-Options": "nosniff",
      "Strict-Transport-Security": "max-age=31536000; includeSubDomains",
      Pragma: "no-cache",
      Expires: "0",
    },
  });

  return next(req);
};
